import { Amplify } from 'aws-amplify'

/**
 * Configure Amplify with Cognito auth + Hosted UI (OAuth PKCE flow).
 * All values come from Vite env vars; set them in .env.local for local dev
 * and in Amplify Console → Environment variables for production.
 *
 * redirectSignIn / redirectSignOut accept comma-separated URLs so you can
 * list both localhost and your production domain in a single env var.
 */
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          // e.g. "birchfolio.auth.us-east-1.amazoncognito.com" (no https://)
          domain: import.meta.env.VITE_COGNITO_OAUTH_DOMAIN,
          scopes: ['email', 'openid', 'profile'],
          // Comma-separated list → array, e.g. "http://localhost:5173,https://app.birchfolio.com"
          redirectSignIn: import.meta.env.VITE_COGNITO_REDIRECT_SIGN_IN.split(','),
          redirectSignOut: import.meta.env.VITE_COGNITO_REDIRECT_SIGN_OUT.split(','),
          responseType: 'code', // PKCE — required for SPAs
        },
      },
    },
  },
})
